import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5db63dbd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "dog_wrapper" }
const _hoisted_3 = ["src"]

import { reactive } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import axios from "axios";

interface apiType {
  message: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DogPage',
  setup(__props) {

const data: apiType = reactive({
  message: "",
});

const getApi = () => {
  axios.get<apiType>("https://dog.ceo/api/breeds/image/random").then((res) => {
    data.message = res.data.message;
    console.log(data);
  });
};

onMounted(getApi);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", { onClick: getApi }, "Change Photo"),
      (data.message)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            loading: "lazy",
            src: data.message,
            alt: ""
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})